import{REQUIRED_ATTR_MESSAGE as t}from"./constants.js";const s=s=>{const n=Object.keys(t).find(t=>t===s);return t[n]};export{s as default};
